var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, when, makeObservable } from 'mobx';
import { runtime } from '../../../runtime/Runtime';
import { LoadStatus, MediaLabel, PlayStatus } from '../../../learnware/LearnwareEnums';
export class VideoIntentHandler {
    intent;
    constructor(intent) {
        makeObservable(this);
        this.intent = intent;
    }
    get video() {
        return this.intent.attachedMedium;
    }
    async play() {
        await when(() => this.intent.app.media.mediaStarter.isAutoPlayPossible);
        this.intent.playStatus = PlayStatus.Go;
        this.video.videoHandler = this;
        if (!this.intervalId) {
            this.intervalId = setInterval(this.checkVideoStatus, 1000);
        }
    }
    intervalId;
    noMoreCheckPosition() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    lastPosition = -1;
    lastProgress = -1;
    checkVideoStatus() {
        if ([PlayStatus.Aborted, PlayStatus.Ended].includes(this.intent.playStatus)) {
            this.noMoreCheckPosition();
            return;
        }
        if (this.intent.questionId !== this.intent.app.questionId) {
            console.log('abort intent because of different questionId');
            this.intent.playStatus = PlayStatus.Aborted;
            return;
        }
        /*
        const videoRendered = Array.from(document.getElementsByTagName('video')).find(v => v.currentSrc.includes(this.intent.medFile.src));
        if (!videoRendered) {
          console.log('abort intent because video is not rendered');
          this.intent.playStatus = PlayStatus.Aborted;
          return;
        } */
    }
    get shouldPlay() {
        // if (videoLayer === 'background') return false;
        if (this.intent.app.appClock.isAppClockPaused)
            return false;
        if (!this.intent.app.media.mediaStarter.isAutoPlayPossible)
            return false;
        if (this.intent.attachedVideo.isStopMarkHindering)
            return false;
        if (this.intent.loadStatus === LoadStatus.Loading)
            return false;
        if ([PlayStatus.Go, PlayStatus.Playing].includes(this.intent.playStatus)) {
            return true;
        }
        return false;
    }
    stop() {
        console.log('abort intent because stop is called');
        this.intent.playStatus = PlayStatus.Aborted;
    }
    onPlay() {
        this.intent.playStatus = PlayStatus.Playing;
        this.intent.startDate = runtime.runtimeClock.currentDate;
    }
    onEnd() {
        this.intent.playStatus = PlayStatus.Ended;
        this.intent.endDate = runtime.runtimeClock.currentDate;
        this.intent.progressInSeconds = this.video.vid.durationInSeconds;
        this.intent.attachedVideo.core.aspectEvents.eventCreation.createAndFireFromRawEvent({ type: 'videoended' });
        if (this.intent.intentSettings.playbackLoop > 0) {
            this.intent.intentSettings.playbackLoop--;
            this.intent.reactPlayer.seekTo(0, 'seconds');
            this.intent.progressInSeconds = 0;
            this.intent.playStatus = PlayStatus.Playing;
        }
        if ([MediaLabel.enforcementTip, MediaLabel.enforcementPush].includes(this.intent.mediumLabel) &&
            runtime.availablePackages.Exotic &&
            this.video.context.app.recognition.isRecognitionRunning) {
            this.video.context.app.recognition.browserRecognition.stop();
        }
    }
}
__decorate([
    action.bound
], VideoIntentHandler.prototype, "play", null);
__decorate([
    action.bound
], VideoIntentHandler.prototype, "checkVideoStatus", null);
__decorate([
    computed
], VideoIntentHandler.prototype, "shouldPlay", null);
__decorate([
    action.bound
], VideoIntentHandler.prototype, "stop", null);
__decorate([
    action.bound
], VideoIntentHandler.prototype, "onPlay", null);
__decorate([
    action.bound
], VideoIntentHandler.prototype, "onEnd", null);
